import * as React from "react"
import { ChevronDown } from "lucide-react"

import { cn } from "@/lib/utils"

/**
 * Native <select> styled like SelectTrigger. For forms that must render under the `node` vitest
 * environment (react-dom/server), or wherever a plain keyboard-native control is enough. The Radix
 * Select stays the choice for the filter bars that already use it.
 */
const NativeSelect = React.forwardRef<HTMLSelectElement, React.ComponentProps<"select">>(
  ({ className, children, ...props }, ref) => (
    <div className="relative">
      <select
        ref={ref}
        className={cn(
          "flex h-9 w-full appearance-none items-center rounded-md border border-input bg-transparent py-2 pl-3 pr-8 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 opacity-50" />
    </div>
  )
)
NativeSelect.displayName = "NativeSelect"

export { NativeSelect }
